<template>
  <!-- star -->

  <div class="youjiaopage_wrap">
    <banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>当前位置：首页><span>产品中心</span></div>
    </div>
    <!-- 招聘信息 -->
    <div class="Recruitment">
        <div class="Recruitment_cont">
            <!-- 折叠菜单 -->
            <div class="asideBox">
              <aside>
                <ul class="asideMenu">
                  <li v-for="(item,index) in menuList" :key="index">
                    <div class="oneMenu" @click="showToggle(item,index,item.type)">
                      <span :class="item.isSubShow ? 'active' : '' " >{{item.name}}</span>
                      <img :class="item.isSubShow ? 'jt-x' : 'jt-y' " v-bind:src="item.imgUrl" alt="" />
                    </div>
                    <ul v-show="item.isSubShow">
                      <li v-for="(subItem,e) in item.subItems" :class="activeID === subItem.id ? 'menu-active' : ''" :key="e" @click="showActive(subItem.id)">
                        <div class="oneMenuChild">{{subItem.name}}</div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </aside>
            </div>

            <!-- 产品列表 -->
            <div class="product-list-view">
              <ul class="product-view fw">
                  <li class="product-cell" v-for="(item, index) in arrList" :key="index" @click="onurl(index)" @mouseenter="handleMouseEnter($event)" @mouseleave="handleMouseLeave($event)">
                      <div class="product-content">
                          <div class="text-view">
                              <h3>{{item.name}}</h3>
                              <p v-if="index == 0 || index % 5 == 0">{{item.introduce}}</p>
                          </div>
                          <div class="img-view">
                            <img class="product-img animate__animated" :class="animationShow ? 'animate__bounceIn' : ''" :src="item.src" alt="" />
                          </div>
                          <div class="see-details">
                            <span>查看详情</span>
                            <i class="icon-see"></i>
                          </div>
                      </div>
                      
                  </li>
              </ul>

              <pagination :total="total" :allPage="allpage" v-on:change="changePage"></pagination>
            </div>

        </div>
        
    </div>
    <!-- 翻页 -->

    <!-- end -->
  </div>
</template>


<script>
import banner2 from "../components/banner.vue";
import pagination from "../components/pagination.vue";
export default {
  name: "zhaopinxinxi",
  components: {
    banner2,
    pagination,
  },
  data() {
    return {
      h1: "产品中心",
      Img1: require("../assets/img/keji/cp_banner.png"),
      p1: "用心智造，守护用电安全",
      animationShow: true,
      allpage: 0,  //总记录数
      size: 10,    //每页显示个数
      current: 1,  //当前显示页
      total: 0,   //总数
      arrList: [
        {
          id: 1,
          src: require('@/assets/index/device_01.jpg'),
					name: '变压器监测仪',
					introduce: '这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介',
        },
        {
          id: 4,
          src: require('@/assets/index/wgwd.jpg'),
					name: '网关微断',
					introduce: '这是简介',
        },
        {
          id: 2,
          src: require('@/assets/index/sb_mccb.png'),
					name: '智能塑壳',
					introduce: '这是简介',
        },
        {
          id: 3,
          src: require('@/assets/index/yanwu.jpg'),
					name: '烟雾报警器',
					introduce: '这是简介',
        },
        {
          id: 8,
          src: require('@/assets/index/sbgl_img_shexiangtou.png'),
					name: '摄像头',
					introduce: '这是简介',
        },
        {
          id: 5,
          src: require('@/assets/index/wndlq_img.png'),
					name: '万能断路器',
					introduce: '这是简介',
        },
        {
          id: 6,
          src: require('@/assets/index/wjzb_img_01.png'),
					name: '微机综保',
					introduce: '这是简介',
        },
        {
          id: 7,
          src: require('@/assets/index/bracelet.jpg'),
					name: '表带测温主机',
					introduce: '这是简介',
        },
        {
          id: 9,
          src: require('@/assets/index/dlcw_img.png'),
					name: '电缆智能监测装置',
					introduce: '这是简介',
        },
        {
          id: 10,
          src: require('@/assets/index/db_01.png'),
					name: '智能电表',
					introduce: '这是简介',
        },
        {
          id: 11,
          src: require('@/assets/index/dgnb_img.jpg'),
					name: '多功能表',
					introduce: '这是简介',
        },
        {
          id: 12,
          src: require('@/assets/index/mccbSurvey.png'),
					name: '塑壳监测模块',
					introduce: '这是简介',
        }
      ],
      activeID: null,
      menuList:[
          {
            name:'智能设备',
            imgUrl:require('@/assets/img/icon_jt.png'),
            isSubShow:true,
            type: 1,
            subItems:[
              {
                name:'变压器监测仪',
                id: 1
              },
              {
                name:'安防监控',
                id: 2
              },
              {
                name:'烟雾报警',
                id: 3
              },
              {
                name:'控损开关',
                id: 4
              },
              {
                name:'微断网关',
                id: 5
              },
              {
                name:'智能塑壳',
                id: 6
              },
              {
                name:'塑壳监测模块',
                id: 7
              },
              {
                name:'表带测温主机',
                id: 8
              },
              {
                name:'微机综保',
                id: 9
              },
              {
                name:'万能断路器',
                id: 10
              },
              {
                name:'电缆智能监测装置',
                id: 11
              },
              {
                name:'多功能表',
                id: 12
              },
              {
                name:'智能电表',
                id: 13
              }
            ]
          },
          {
            name:'运维设备',
            imgUrl:require('@/assets/img/icon_jt.png'),
            isSubShow:false,
            type: 2,
            subItems:[
              {
                name:'运维设备',
                id: 14
              }
            ]
          },
          {
            name:'服务中心',
            imgUrl:require('@/assets/img/icon_jt.png'),
            isSubShow:false,
            type: 3,
            subItems:[
              {
                name:'电力抢修',
                id: 15
              },
              {
                name:'电力运维',
                id: 16
              },
              {
                name:'电力巡检',
                id: 17
              },
              {
                name:'配电改造',
                id: 18
              },
              {
                name:'带电检测',
                id: 19
              }
            ]
          }
        ]
    };
  },

  created(){
      this.allpage = 29;
      //总页数
      this.total = 3;
  },
  methods: {
    // 点击展开折叠菜单事件
    showToggle:function(item,ind,type){
        this.activeID = null;
        this.menuList.forEach(i => {
          // 判断如果数据中的menuList[i]的show属性不等于当前数据的isSubShow属性那么menuList[i]等于false
          //  || i.type == this.menuList[ind].type
          if (i.isSubShow !== this.menuList[ind].isSubShow) {
            i.isSubShow = false;//此处有可能不生效，数据变了，但是视图可能没更新，可以换成$set
            // this.$set(i,'isSubShow ',false)
          }

        });
        item.isSubShow = !item.isSubShow;
        // this.$set(item,'isSubShow ',!item.isSubShow)
        console.log(item.name,type)
    },

    changePage:function(index){
      this.current = index;
      // this.getList();
    },

    // 点击选中
    showActive(id){
        console.log(id);
        this.activeID = id;
        
    },


    handleMouseEnter($event) {
      // 处理鼠标移入时的操作
      // 处理鼠标移入事件
      $event.currentTarget.className = 'product-cell active'
      // this.animationShow = true;
    },
    handleMouseLeave($event) {
      // 处理鼠标移出时的操作
      // this.animationShow = false;
      $event.currentTarget.className = 'product-cell'
    },
    onurl(index) {
      // this.$router.push({
      //   path: "/productDetails",
      //   query: {id: index}
      // })
      this.$router.push({
        path: `/productDetails/${index}`
      })
      
    },
  },
};
</script>
<style scoped>
@import "../assets/css/recruit-info.css";
.asideBox{
  height: 100%;
  width: 280px;
  padding-right: 10px;
  padding-top: 10px
}
.asideMenu{
  padding-top: 20px;
  padding-bottom: 20px;
}
.asideBox aside{
  background: #ffffff;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
  height: 100%;
}
.oneMenu{
  height: 50px;
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  /*border-bottom: 1px solid #669cd9;*/
  cursor: pointer;
  padding: 10px 24px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}
.oneMenu .active{
  color: #4CCE9D;
}
.oneMenu img{
  width: 18px;
  height: 18px;
  vertical-align: top;
} 
.oneMenuChild{
  padding: 0 20px 0 60px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  color: #666666;
  font-size: 14px;
  cursor: pointer;
}
.menu-active .oneMenuChild{
  color: #4CCE9D;
}
.jt-x{
  transition: transform .3s;
  transform: rotate(90deg);
}   
.jt-y{
  transition: transform .3s;
  transform: rotate(0deg);
}   
.see-details{
  position: absolute;
  right: 30px;
  bottom: 20px;
  z-index: 2;
  color: #999999;
  font-size: 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.see-details .icon-see{
  width: 18px;
	height: 18px;
	background-image: url("../assets/icon/icon_jt_01.png");
	background-size: 100% 100%;
  display: block;
  margin-left: 5px;
}
.product-view .product-cell .product-content:hover .see-details{
  color: #4CCE9D;
}
.product-view .product-cell .product-content:hover .see-details .icon-see{
  background-image: url("../assets/icon/icon_jt_02.png");
	background-size: 100% 100%;
}
.product-view {
    display: -webkit-flex;
    display: flex;
    overflow: hidden;
    width: 100%;
}
.product-list-view{
  flex: 1;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.product-view .product-cell{
  width: 33.33%;
  padding: 10px 10px;
}
.product-view .product-cell .product-content{
  display: block!important;
  position: relative;
}
.product-view .product-cell:nth-child(5n+1){
  width: 66.66%;
}
.product-view .product-cell:nth-child(5n+1) .product-content{
  display: flex!important;
}
.product-view .product-cell:nth-child(1){
  width: 66.66%;
}
.product-view .product-cell:nth-child(1) .product-content{
  display: flex!important;
}
.product-view .product-cell:nth-child(5n+1) .product-content .see-details{
  position: absolute;
  right: initial;
  bottom: 20px;
  left: 30px;
}
.product-view .product-cell:nth-child(5n+1) .product-content .text-view h3:after,
.product-view .product-cell:nth-child(5n+1) .product-content .text-view h3:before{
  display: block;
}
.product-view .product-cell .product-content .img-view{
  align-items: initial!important;
  padding-left: 0!important;
  -webkit-justify-content: center;
  justify-content: center;
}
.product-view .product-cell:nth-child(1) .product-content .img-view,
.product-view .product-cell:nth-child(5n+1) .product-content .img-view{
  align-items: center!important;
}
.product-view .product-cell:nth-child(1) .product-content .text-view,
.product-view .product-cell:nth-child(5n+1) .product-content .text-view{
  padding-right: 80px
}
.product-view .product-cell .product-content{
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
  border-radius: 9px;
  overflow: hidden;
  cursor: pointer;
  height: 360px;
  display: -webkit-flex;
  padding: 20px 40px;
  display: flex;
}
.product-view .product-cell .product-content:hover .text-view h3{
  color: #4CCE9D;
}
.product-view .product-cell.active .product-img{
  -webkit-animation-duration: calc(1s * 0.75);
  animation-duration: calc(1s * 0.75);
  -webkit-animation-duration: calc(var(--animate-duration) * 0.75);
  animation-duration: calc(var(--animate-duration) * 0.75);
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
}
/* Bouncing entrances  */
@-webkit-keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
.img-view{
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  padding-left: 30px;
}
.product-content .product-img{
    width: 150px;
    height: 150px;
    object-fit: contain;
}
.product-content .text-view{
  flex: 1;
}
.product-content .text-view h3{
  font-size: 22px;
  color: #333333;
  line-height: 60px;
  margin-bottom: 30px;
  font-weight: normal;
  position: relative;
}
.product-content .text-view h3:after{
  display: none;
  width: 20%;
  height: 2px;
  background: #ededed;
  content: "";
  border: none;
  position: absolute;
  left: 0;
  bottom: 0;
  margin-top: 20px;
  -webkit-transition: width .3s;
  -o-transition: width .3s;
  transition: width .3s;
}
.product-content .text-view h3:before{
  display: none;
  width: 100%;
  height: 2px;
  background: #ededed;
  content: "";
  border: none;
  position: absolute;
  left: 0;
  bottom: 0;
  margin-top: 20px;
  -webkit-transition: width .3s;
  -o-transition: width .3s;
  transition: width .3s;
}
.product-view .product-cell .product-content:hover .text-view h3:after{
  background: #4CCE9D;
}
.product-content .text-view p{
  color: #6f6f6f;
  font-size: 14px;
  line-height: 25px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


